'use client';

import { useIdentityContext } from '@cc-shopping/platform-analytics/IdentityContext';
import { Skeleton } from '@mui/material';
import { Box } from '@mui/system';
import { ApprovalOddsGraphContent } from './ApprovalOddsGraphContent';
import { ApprovalOddsTextContent } from './ApprovalOddsTextContent';
import { useUserCreditScore } from './hooks';
export type Odds = {
  max: number;
  min: number;
};
export type ApprovalOddsAnalytics = {
  elementPosition?: number;
  sectionName?: string;
  sectionPosition?: number;
  activityId?: string;
  parentActivityId?: string;
};
export type ApprovalOddsProps = {
  odds: Odds;
  analytics?: ApprovalOddsAnalytics;
  hasLimitedCreditHistory?: boolean;
  hideOddsButton?: boolean;
  smallApprovalLabelText?: boolean;
  smallScoreRangeText?: boolean;
  textContent?: boolean;
  graphContent?: boolean;
  hideTooltip?: boolean;
  hideOddsButtonArrow?: boolean;
  firePageActionOnClick?: boolean;
  isAmexOffer?: boolean;
  type?: 'default' | 'reviews';
};
export default function ApprovalOdds({
  odds,
  analytics,
  hideOddsButtonArrow = true,
  hasLimitedCreditHistory = false,
  hideOddsButton = false,
  smallApprovalLabelText = false,
  smallScoreRangeText = false,
  textContent = false,
  graphContent = false,
  hideTooltip = false,
  firePageActionOnClick = false,
  type = 'default',
  isAmexOffer
}: ApprovalOddsProps) {
  const {
    identity,
    isLoading
  } = useIdentityContext();
  const {
    creditScalar,
    isBelowMin,
    userCreditScore
  } = useUserCreditScore({
    identity,
    odds
  });
  const fromReviews = type === 'reviews';
  if (isLoading) {
    return <Skeleton height={fromReviews ? 60 : 124} {...fromReviews && {
      width: '75%'
    }} />;
  }
  return <>
      <Box width="100%">
        {/* Desktop View */}
        <Box sx={theme => ({
        px: graphContent ? '20px' : 0,
        [theme.breakpoints.down('md')]: {
          display: graphContent ? 'block' : 'none'
        },
        [theme.breakpoints.up('md')]: {
          display: textContent ? 'none' : 'block',
          px: fromReviews ? '20px' : graphContent ? '40px' : 0
        }
      })}>
          <ApprovalOddsGraphContent analytics={analytics} identity={identity} odds={odds} userCreditScore={userCreditScore} creditScalar={creditScalar} isBelowMin={isBelowMin} hasLimitedCreditHistory={hasLimitedCreditHistory} hideOddsButton={hideOddsButton} smallApprovalLabelText={smallApprovalLabelText} smallScoreRangeText={smallScoreRangeText} hideTooltip={hideTooltip} firePageActionOnClick={firePageActionOnClick} hideOddsButtonArrow={hideOddsButtonArrow} isAmexOffer={isAmexOffer} />
        </Box>

        {/* Mobile View */}
        <Box sx={theme_0 => ({
        [theme_0.breakpoints.down('md')]: {
          display: graphContent ? 'none' : 'block'
        },
        [theme_0.breakpoints.up('md')]: {
          display: textContent ? 'block' : 'none'
        }
      })}>
          <ApprovalOddsTextContent analytics={analytics} userCreditScore={userCreditScore} odds={odds} hideOddsButton={hideOddsButton} hideTooltip={hideTooltip} firePageActionOnClick={firePageActionOnClick} isAmexOffer={isAmexOffer} />
        </Box>
      </Box>
    </>;
}